import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileCompanyBannerAPI } from 'features/profile/api'
import { userData } from 'features/user/store'
import {
  PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_REQUEST,
  PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_SUCCESS,
  PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_FAILED,
} from './actionTypes'

export const profileEmployerCompanyBannerRemovePA = createPromiseAction(
  PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_REQUEST,
  PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_SUCCESS,
  PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_FAILED
)()

function* remove(action) {
  try {
    const response = yield call(profileCompanyBannerAPI.deleteBanner)
    const { data } = response

    yield put(profileEmployerCompanyBannerRemovePA.success({}))

    yield put(userData.updateEmployerProfile({ company_banner: null }))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* removeSaga() {
  yield takeEvery(profileEmployerCompanyBannerRemovePA.request, remove)
}
